function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.43247 16.0038V1.40424C5.43247 0.628706 4.80376 0 4.02823 0C3.25271 0 2.624 0.628706 2.624 1.40424V16.0038C1.09553 16.576 0 18.048 0 19.776C0 21.504 1.09553 22.976 2.624 23.5482V30.5882C2.624 31.3638 3.25271 31.9925 4.02823 31.9925C4.80376 31.9925 5.43247 31.3638 5.43247 30.5882V23.5482C6.96471 22.976 8.06024 21.504 8.06024 19.776C8.05647 18.048 6.96094 16.576 5.43247 16.0038Z",
  fill: "#8E8B99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.4044 5.82024V1.40424C17.4044 0.628706 16.7757 0 16.0002 0C15.2246 0 14.5959 0.628706 14.5959 1.40424V5.82024C13.0637 6.39247 11.9719 7.86447 11.9719 9.59247C11.9719 11.3205 13.0675 12.7925 14.5959 13.3647V30.5882C14.5959 31.3638 15.2246 31.9925 16.0002 31.9925C16.7757 31.9925 17.4044 31.3638 17.4044 30.5882V13.3647C18.9366 12.7925 20.0284 11.3205 20.0284 9.59247C20.0284 7.86447 18.9329 6.39247 17.4044 5.82024Z",
  fill: "#8E8B99"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 23.0099C32 21.2819 30.9044 19.8099 29.376 19.2376V1.40424C29.3722 0.628706 28.7472 0 27.9717 0C27.1962 0 26.5675 0.628706 26.5675 1.40424V19.2376C25.039 19.8099 23.9435 21.2819 23.9435 23.0099C23.9435 24.7379 25.039 26.2099 26.5675 26.7821V30.5882C26.5675 31.3638 27.1962 31.9925 27.9717 31.9925C28.7472 31.9925 29.376 31.3638 29.376 30.5882V26.7784C30.9044 26.2099 32 24.7341 32 23.0099Z",
  fill: "#8E8B99"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 31.9887,
  fill: "white"
})));

var SvgWorkbenchIcon = function SvgWorkbenchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWorkbenchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/workbenchIcon.08f9a847.svg";
export { ForwardRef as ReactComponent };